export const BRAND_ABILITY = [
    { subject: "brand-dashboard", action: "manage" },
    { subject: "brand-setup", action: "manage" },
    { subject: "brand-publishers", action: "manage" },
    { subject: "brand-publisher-contract", action: "manage" },
    { subject: "brand-debit-notes", action: "manage" },
    { subject: "brand-disbursements", action: "manage" },
    { subject: "brand-smtp", action: "manage" },
    { subject: "brand-guide", action: "manage" }
];
